import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, WEIGHT_LOSS_EXAM, IV_THERAPY_EXAM } from '../constants';

function ExamPaymentPage() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');
  const type = queryParams.get('type');

  const [loadingRequestId, setLoadingRequestId] = useState(true);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [error, setError] = useState(null);
  const [requestId, setRequestId] = useState('');
  const maxRetries = 3;
  const retryInterval = 5000;

  const getMeetingLink = async (retryCount = 0) => {
    try {
      let response;

      if (type === WEIGHT_LOSS_EXAM) {
        response = await axios.get(
          `${BASE_URL}/request/weightLoss/exam/link?email=${email}`
        );
      } else if (type === IV_THERAPY_EXAM) {
        response = await axios.get(
          `${BASE_URL}/request/ivTherapy/exam/link?email=${email}`
        );
      }

      setRequestId(response.data.requestId);
    } catch (error) {
      console.error('Error fetching request details:', error);

      if (retryCount < maxRetries) {
        setTimeout(() => {
          getMeetingLink(retryCount + 1);
        }, retryInterval);
      } else {
        setError(
          error.response?.data?.error ||
            'Failed to process your request after multiple attempts. Please try again later.'
        );
        setLoadingRequestId(false);
      }
    } finally {
      if (!error) setLoadingRequestId(false);
    }
  };

  useEffect(() => {
    if (email && type) {
      getMeetingLink();
    } else {
      setError('Missing required parameters: email and type.');
      setLoadingRequestId(false);
    }
  }, [email, type]);

  useEffect(() => {
    const getPaymentLink = async () => {
      try {
        setLoadingPayment(true);

        let response;

        if (type === WEIGHT_LOSS_EXAM) {
          response = await axios.post(`${BASE_URL}/payment/weightLoss/exam`, {
            requestId,
          });
        } else if (type === IV_THERAPY_EXAM) {
          response = await axios.post(`${BASE_URL}/payment/ivTherapy/exam`, {
            requestId,
          });
        }

        window.location.href = response.data.url;
      } catch (error) {
        console.error('Error sending request:', error);
        setError(
          error.response?.data?.error ||
            'Failed to process your request. Please try again later.'
        );
      } finally {
        setLoadingPayment(false);
      }
    };

    if (requestId) {
      getPaymentLink();
    }
  }, [requestId, type]);

  if (loadingRequestId || loadingPayment) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='flex flex-col items-center'>
          <div className='loader'></div>
          <p className='mt-8 text-lg'>
            {loadingRequestId
              ? 'Fetching request details...'
              : 'Redirecting to payment...'}
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='text-center p-6 bg-white rounded-lg shadow-lg'>
          <h2 className='text-2xl font-semibold text-red-600'>Error</h2>
          <p className='mt-4'>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className='mt-6 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700'
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
      <p className='text-lg'>Redirecting to payment...</p>
    </div>
  );
}

export default ExamPaymentPage;
